/**
 * This file consolidates seo logic within website/client
 */
export type SeoCategory = (typeof SEO_CATEGORIES)[number];

export const SEO_CATEGORIES = [
  "arts-and-crafts",
  "dance",
  "guitar",
  "math",
  "music",
  "spanish",
] as const;

export const SEO_CATEGORIES_NICE = {
  "arts-and-crafts": "art",
  spanish: "Spanish",
};

export function isSeoCategory(categorySlug: string): boolean {
  return (SEO_CATEGORIES as any).includes(categorySlug);
}

export function seoWhyAttendBlurb(categorySlug: SeoCategory): string {
  const displayName = niceCategoryName(categorySlug);
  return `An online ${displayName} class is similar to an in-person ${displayName} class but with more options and freedom! Outschool teachers offer online ${displayName} classes that meet live, in a one-on-one setting, or asynchronously for those times when you need things to fit around your schedule. Beginner, intermediate, and advanced level learning to meet your child's needs.`;
}

export function seoWhyAttendTitle(categorySlug: SeoCategory): string {
  const displayName = niceCategoryName(categorySlug);
  return `Why take an online ${displayName} class?`;
}

function niceCategoryName(categorySlug: SeoCategory): string {
  return Object.keys(SEO_CATEGORIES_NICE).includes(categorySlug)
    ? // @ts-ignore
      SEO_CATEGORIES_NICE[categorySlug]
    : categorySlug;
}
